<template>
  <div>
    <b-tabs fill>
      <b-tab active title="Prenotazione con ricetta elettronica">
        <prenotazione-nre @getInfoUtente="getInfoUtente"></prenotazione-nre>
      </b-tab>
      <b-tab title="Prenotazione libero professionale">
        <div v-if="jsonData.assistito !== null">
          <prenotazione-alpi :assistito="jsonData.assistito"></prenotazione-alpi>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import prenotazioneAlpi from "../alpi/prenotazioneAlpi.vue";
import PrenotazioneNre from "../nre/prenotazioneNre.vue";
import utilityMixin from "../../utilities/utilityMixin";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  mixins: [utilityMixin],
  components: {
    PrenotazioneNre,
    prenotazioneAlpi,
  },
  data() {
    return {
      jsonData: {
        assistito: {
          provinciaResidenza: null,
        },
      },
    };
  },
  computed: {},
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    if(!sessionStorage.getItem('popUpTest')){
        sessionStorage.setItem("popUpTest",'true');
        let msg = getVocabolario("avvisoHome")
        if(msg){
            this.$bvModal
                .msgBoxOk(msg, {
                    title: "Attenzione!",
                    size: "lg",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
        }
    }
  },
  methods: {
    getInfoUtente(item) {
      let me = this;
      me.jsonData.assistito = item;
    },
  },
};
</script>

<style scoped>
.nav-link {
  color: #274561;
  font-weight: bold;
}
.nav-tabs {
  background-color: #01803c !important;
}
</style>
